import { bookingSummaryService, dynamicLinkService } from '@/infrastructure/Factory'
import { getPageLanguage, isTaxIncludedRegion } from '@/infrastructure/Utils'
import { translate } from 'rhg-vue-common'
import helper from '../../helpers/errorModal'

export default {
  async getBookingDetailsInfo({ commit, dispatch }, bookingHeader) {
    commit('fetchingBookingInfo')

    let bookingDetails
    try {
      bookingDetails = await bookingSummaryService.getBookingDetails(bookingHeader)
      window.appGlobalProps = {
        ...window.appGlobalProps,
        upsellingSlider: {
          booking: bookingDetails
        }
      }
      commit('setBookingDetails', bookingDetails)
    } catch (e) {
      dispatch('handleBookingError', e.response.data)
      return
    }

    commit('fetchedBookingInfo')
  },

  async setupDynamicLinkInfo({ commit }, booking) {
    commit('fetchingDynamicLinkInfo')
    commit('setDynamicLinkInfo', false)

    try {
      const dynamicLinkInfo = await dynamicLinkService.getDynamicLinkInfo(booking.stay.hotelCode)
      const linkElement = dynamicLinkInfo.links.find(link => link.page === 'BOOKING_SUMMARY')

      if (linkElement === undefined) {
        commit('setDynamicLinkInfo', [])
        return
      }

      try {
        let url
        let preparedParameters = linkElement.parameters

        if (linkElement.encrypted) {
          url = await dynamicLinkService.getEncryptedDynamicLink(linkElement, booking)
        } else {
          preparedParameters = dynamicLinkService.prepareDynamicLinkParams(linkElement, booking)
          url = dynamicLinkService.getNonEncryptedDynamicLink({
            ...linkElement,
            parameters: preparedParameters
          })
        }

        commit('setDynamicLinkInfo', [{ ...linkElement, parameters: preparedParameters, url }])
      } catch (e) {
        console.error('[DYNAMIC LINK] Problem preparing link.', e)
        return null
      }
    } catch (e) {
      console.error(e)
      commit('setDynamicLinkInfo', [])
    } finally {
      commit('fetchedDynamicLinkInfo')
    }
  },

  async getBookingHotelsInfo({ getters, commit }, tier) {
    const hotelCode = getters.booking.stay.hotelCode
    if (hotelCode) {
      commit('fetchingHotelInfo')

      const { hotel, benefits, coBrandImage } = await bookingSummaryService.getHotelDetails(
        hotelCode,
        tier
      )
      commit('setHotelDetails', { hotel, benefits, coBrandImage })

      commit('fetchedHotelInfo')
    }
  },

  async modifyRoom({ getters, dispatch }, data) {
    await bookingSummaryService.modifyBooking(data)
    const {
      mainGuest: { firstName, lastName }
    } = data
    const { bookingId } = getters.bookingHeader
    const updateBookingHeader = {
      firstName,
      lastName,
      bookingId
    }
    dispatch('getBookingDetailsInfo', updateBookingHeader)
  },

  displayBookingSkeleton({ commit }) {
    commit('fetchingBookingInfo')
  },

  removeBookingSkeleton({ commit }) {
    commit('fetchedBookingInfo')
  },

  handleBookingError({ _ }, error) {
    if (error?.status === 404 && error?.type === 'problem:itinerary-not-found-us-property') {
      global.ModalMsg.show(
        '#modal-error',
        { title: translate('errBmItineraryNotFound') },
        null,
        null,
        {
          url: `/${getPageLanguage().toLowerCase()}/reservation/search`,
          label: translate('errBmErrorCta'),
          show: true
        }
      )
    } else {
      global.ModalMsg.show('#modal-error')
    }
  },

  async applyVoucher({ getters }, data) {
    const { bookingId } = getters.bookingHeader
    await bookingSummaryService.applyVoucher(bookingId, data)
  },

  async redirectToPayment({ getters }) {
    const { bookingId, firstName, lastName } = getters.bookingHeader
    const data = {
      firstName,
      lastName,
      bookingId,
      isTaxIncludedRegion: isTaxIncludedRegion()
    }
    const { gateway } = await bookingSummaryService.getPaymentGetwayInfo(data)
    try {
      const form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('name', 'myform')
      form.setAttribute('target', '_top')
      form.setAttribute('action', gateway.url)
      form.setAttribute('id', 'online-payments-form')
      if (gateway.data && gateway.data.length > 1) {
        for (let i = 0; i < gateway.data.length; i++) {
          const input = document.createElement('input')
          input.setAttribute('type', 'hidden')
          input.setAttribute('name', gateway.data[i].key)
          input.value = gateway.data[i].value
          form.append(input)
        }
      } else {
        const input2 = document.createElement('input')
        input2.setAttribute('type', 'hidden')
        input2.setAttribute('name', gateway.name)
        input2.value = gateway.token
        form.append(input2)
      }
      // eslint-disable-next-line no-undef
      document.body.appendChild(form)
      // eslint-disable-next-line no-undef
      $('#online-payments-form').submit()
    } catch (error) {
      console.log(error)
    }
  },

  trackRoomCancelReservation() {
    global.trackingService.track(global.trackingEvents.CLICK_CANCEL_RESERVATION)
  },

  trackRoomModifyReservation() {
    global.trackingService.track(global.trackingEvents.CLICK_MODIFY_RESERVATION)
  },

  trackSuccessReservationModification() {
    global.trackingService.track(global.trackingEvents.SUCCESSFUL_RESERVATION_MODFICATION)
  },

  trackCancellationStart() {
    global.trackingService.track(global.trackingEvents.CANCELLATION_START)
  },

  trackAddPromoCodeApplied() {
    global.trackingService.track(global.trackingEvents.PROMO_CODE_APPLIED)
  },

  trackAddPromoCodeDeleted() {
    global.trackingService.track(global.trackingEvents.PROMO_CODE_DELETED)
  },

  trackErrorPromoCode() {
    global.trackingService.track(global.trackingEvents.ERROR_PROMO_CODE)
  },
  trackMyReservationsRequestInvoice() {
    global.trackingService.track(global.trackingEvents.MYRESERVATIONS_REQUEST_INVOICE)
  },
  async getOnlinePaymentError({ commit }, error) {
    const { errorFactoryModal } = helper()
    error && errorFactoryModal(error)
    commit('error') // todo
  }
}
